"use strict";
exports.__esModule = true;
exports.calculateEstimatedFees = exports.getBufferFromString = exports.methodToString = exports.isError = exports.isValidBase64 = exports.isValidHex = exports.getPath = exports.isNoErrorReturnCode = void 0;
var validHexRegExp = new RegExp(/[0-9A-Fa-f]{6}/g);
var validBase64RegExp = new RegExp(/^(?:[A-Za-z\d+/]{4})*(?:[A-Za-z\d+/]{3}=|[A-Za-z\d+/]{2}==)?$/);
// TODO Filecoin - Use the new package @zondax/ledger-utils instead
var isNoErrorReturnCode = function (code) { return code === 0x9000; };
exports.isNoErrorReturnCode = isNoErrorReturnCode;
var getPath = function (path) {
    return path && path.substr(0, 2) !== "m/" ? "m/".concat(path) : path;
};
exports.getPath = getPath;
var isValidHex = function (msg) { return validHexRegExp.test(msg); };
exports.isValidHex = isValidHex;
var isValidBase64 = function (msg) { return validBase64RegExp.test(msg); };
exports.isValidBase64 = isValidBase64;
var isError = function (r) {
    if (!(0, exports.isNoErrorReturnCode)(r.return_code))
        throw new Error("".concat(r.return_code, " - ").concat(r.error_message));
};
exports.isError = isError;
var methodToString = function (method) {
    switch (method) {
        case 0:
            return "Transfer";
        default:
            return "Unknown";
    }
};
exports.methodToString = methodToString;
var getBufferFromString = function (message) {
    return (0, exports.isValidHex)(message)
        ? Buffer.from(message, "hex")
        : (0, exports.isValidBase64)(message)
            ? Buffer.from(message, "base64")
            : Buffer.from(message);
};
exports.getBufferFromString = getBufferFromString;
var calculateEstimatedFees = function (gasFeeCap, gasLimit) { return gasFeeCap.multipliedBy(gasLimit); };
exports.calculateEstimatedFees = calculateEstimatedFees;
//# sourceMappingURL=utils.js.map